import { Menu, useResourceDefinitions } from 'react-admin';

import MovieIcon from '@mui/icons-material/Movie';
import { createElement } from 'react';

const MenuLayout = () => {
  const resources = useResourceDefinitions();

  return (
    <Menu>
      {Object.keys(resources).map((name) => (
        <Menu.Item
          key={name}
          to={`/${name}`}
          primaryText={(resources[name].options && resources[name].options.label) || name}
          leftIcon={createElement(resources[name].icon)}
        />
      ))}
      <Menu.Item to="/app/media/storage" primaryText="Медиа файлы" leftIcon={<MovieIcon />} />
    </Menu>
  );
};

export default MenuLayout;
